import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Tours from './pages/Tours';
import Guides from './pages/Guides';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import SignUp from './pages/SignUp';
import Admin from './pages/Admin';
import ExploreSchools from './pages/ExploreSchools';
import SchoolDetail from './pages/SchoolDetail';
import GuideProfile from './pages/GuideProfile';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentPage from './pages/PaymentPage';
import TipPage from './pages/TipPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/contacts" element={<ContactUs />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/explore-schools" element={<ExploreSchools />} />
          <Route path="/school/:schoolId" element={<SchoolDetail />} />
          <Route path="/guide/:guideId" element={<GuideProfile />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment/:bookingId" element={<PaymentPage />} />
          <Route path="/tip/:bookingId" element={<TipPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;